import { render, staticRenderFns } from "./bulk.vue?vue&type=template&id=40053846&scoped=true"
import script from "./bulk.vue?vue&type=script&lang=js"
export * from "./bulk.vue?vue&type=script&lang=js"
import style0 from "./bulk.vue?vue&type=style&index=0&id=40053846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40053846",
  null
  
)

export default component.exports